const TOGGLE_ACTIVE_CLASS = 'is--active'
const ARIA_LABEL = 'aria-label'

class passwordsToggle {
  constructor(element) {
    this.element = element
    this.input = document.querySelector(`[${this.element.dataset.inputHook}]`)
    this.btnHidden = this.element.dataset.hidden
    this.btnVisible = this.element.dataset.visible
    this.inputHidden = this.input.dataset.hidden
    this.inputVisible = this.input.dataset.visible

    this.bindEvents()
  }

  bindEvents() {
    this.element.addEventListener('click', () => this.setInputType())
  }

  setInputType() {
    if (this.input.type === 'password') {
      this.input.setAttribute('type', 'text')
      this.input.setAttribute(ARIA_LABEL, this.inputVisible)
      this.element.setAttribute(ARIA_LABEL, this.btnVisible)
      this.element.classList.add(TOGGLE_ACTIVE_CLASS)
    } else {
      this.input.setAttribute('type', 'password')
      this.input.setAttribute(ARIA_LABEL, this.inputHidden)
      this.element.setAttribute(ARIA_LABEL, this.btnHidden)
      this.element.classList.remove(TOGGLE_ACTIVE_CLASS)
    }
  }
}

export default passwordsToggle
